import { PatrolCommunitySource } from '../models/patrol-community-source.model';

export const PATROL_COMMUNITY_SOURCES: ReadonlyArray<PatrolCommunitySource> = [
  {
    id: 'discord',
    nameKey: 'app.patrol.communities.discord.name',
    descriptionKey: 'app.patrol.communities.discord.description',
    logoSrc: '/public/logos/discord.svg',
    route: 'discord',
    available: true,
  },
  {
    id: 'roblox',
    nameKey: 'app.patrol.communities.roblox.name',
    descriptionKey: 'app.patrol.communities.roblox.description',
    logoSrc: '/public/logos/roblox.svg',
    route: 'roblox',
    available: true,
  },
  {
    id: 'minecraft',
    nameKey: 'app.patrol.communities.minecraft.name',
    descriptionKey: 'app.patrol.communities.minecraft.description',
    logoSrc: '/public/logos/minecraft.svg',
    route: 'minecraft',
    available: false,
    comingSoonKey: 'app.patrol.communities.comingSoon',
  },
];
